<template>
  <div class="exam-uniform-schedule-room-title">
    <div class="label">{{title}}</div>
    <div v-if="getAttach"
         class="extra">
      <span>考生数<span class="digit theme-text">{{getAttach.studentCount || 0}}</span>人</span>
      <span>已安排<span class="digit is-warning">{{getAttach.arrangeCount || 0}}</span>人</span>
      <el-divider direction="vertical"></el-divider>
      <span>考场数<span class="digit theme-text">{{getAttach.examRoomCount || 0}}</span>个</span>
      <span>已安排<span class="digit is-warning">{{getAttach.examRoomUsed || 0}}</span>个</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamUniformScheduleRoomTitle',
  props: {
    grid: {
      type: Object,
      required: true
    },
    title: String
  },
  computed: {
    getAttach () {
      if (this.grid.data && this.grid.data.raw) {
        return this.grid.data.raw.attached
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../../styles/color";
  .exam-uniform-schedule-room-title {
    flex: auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    & > .label {
      flex: none;
      font-size: 15px;
    }
    & > .extra {
      margin-left: 30px;
      flex: auto;
      overflow: hidden;
      color: #606266;
      white-space: nowrap;
      text-overflow: ellipsis;
      span {
        font-size: 12px;
        & + span {
          margin-left: 10px;
        }
      }
      .digit {
        margin-left: 4px;
        margin-right: 3px;
        font-size: 120%;
        vertical-align: -1px;
      }
      .is-warning {
        color: $set-warning-color;
      }
    }
  }
</style>
